module.exports = __webpack_public_path__ + "2acb60f2/img/question-icon.06c20c5d.svg";